module.exports = {
	"id": "SI",
	"name": "Slovenia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.022944,
			"12": 0.007648,
			"13": null,
			"14": 0.007648,
			"15": 0.007648,
			"16": 0.007648,
			"17": null,
			"18": null,
			"19": 0.007648,
			"20": 0.007648,
			"21": 0.007648,
			"22": 0.030592,
			"23": 0.015296,
			"24": 0.007648,
			"25": 0.015296,
			"26": 0.015296,
			"27": null,
			"28": null,
			"29": 0.022944,
			"30": 0.030592,
			"31": 0.068832,
			"32": null,
			"33": 0.022944,
			"34": 0.030592,
			"35": 0.030592,
			"36": 0.022944,
			"37": 0.022944,
			"38": 0.03824,
			"39": 0.091776,
			"40": 0.030592,
			"41": 0.022944,
			"42": 0.022944,
			"43": 0.099424,
			"44": 0.053536,
			"45": 0.030592,
			"46": 0.045888,
			"47": 0.07648,
			"48": 0.084128,
			"49": 2.118496,
			"50": 0.145312,
			"51": 0.734208,
			"52": 0.405344,
			"53": 28.052864,
			"54": 7.166176,
			"55": 0.099424,
			"56": 0.03824,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": 0.007648,
			"5": 0.007648,
			"6": null,
			"7": 0.007648,
			"8": null,
			"9": 0.015296,
			"10": 0.007648,
			"11": 0.015296,
			"12": 0.007648,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.007648,
			"17": 0.053536,
			"18": 0.007648,
			"19": 0.015296,
			"20": 0.015296,
			"21": 0.007648,
			"22": null,
			"23": 0.007648,
			"24": 0.015296,
			"25": 0.015296,
			"26": 0.030592,
			"27": 0.007648,
			"28": 0.022944,
			"29": 0.015296,
			"30": 0.015296,
			"31": 0.045888,
			"32": 0.022944,
			"33": 0.015296,
			"34": 0.015296,
			"35": 0.015296,
			"36": 0.015296,
			"37": 0.03824,
			"38": 0.107072,
			"39": 0.053536,
			"40": 0.03824,
			"41": 0.122368,
			"42": 0.053536,
			"43": 0.206496,
			"44": 0.061184,
			"45": 0.26768,
			"46": 0.122368,
			"47": 0.84128,
			"48": 0.72656,
			"49": 17.7816,
			"50": 0.07648,
			"51": 0.007648,
			"52": 0.007648,
			"3.5": 0.107072,
			"3.6": 0.015296
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.030592,
			"37": 0.022944,
			"38": 0.107072,
			"39": 0.007648,
			"40": 0.711264,
			"41": 0.099424,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.007648,
			"12.1": 0.084128
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.022944,
			"6": null,
			"7": 0.022944,
			"8": 0.137664,
			"9": 0.160608,
			"10": 1.277216,
			"3.1": null,
			"3.2": null,
			"5.1": 0.068832,
			"6.1": 0.045888,
			"7.1": 0.022944,
			"9.1": 0.711264
		},
		"ios_saf": {
			"8": 0,
			"10": 2.95034997502,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0795085179017,
			"8.1-8.4": 0.146888617818,
			"9.0-9.2": 0.0700753039134,
			"9.3": 1.06909758535
		},
		"android": {
			"3": 0,
			"4": 0.0236537054264,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00295671317829,
			"4.1": 0.0853222945736,
			"4.2-4.3": 0.213305736434,
			"4.4": 0.489124837209,
			"4.4.3-4.4.4": 0.493348713178
		},
		"ie": {
			"6": 0.0153398699809,
			"7": 0.00766993499044,
			"8": 0.268447724665,
			"9": 0.253107854685,
			"10": 0.299127464627,
			"11": 7.17905915105,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0103808090618,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000288355807271
		},
		"edge": {
			"12": 0.084128,
			"13": 0.49712,
			"14": 1.629024
		},
		"ie_mob": {
			"10": 0.086262084507,
			"11": 0.351209915493
		},
		"bb": {
			"7": 0.009996,
			"10": null
		},
		"samsung": {
			"0": 2.907072
		},
		"and_uc": {
			"0": 0.037632
		},
		"op_mini": {
			"0": 0.139858835131
		},
		"and_chr": {
			"0": 15.089776
		},
		"and_ff": {
			"0": 0.032928
		}
	},
	"total": 98.902924
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SI.json
 ** module id = 644
 ** module chunks = 0
 **/